/* 7B header (Oct 20, 2026; v2 Oct 23: one sticky header, no compact variant) + phone drawer extras. See sections/7b-header.liquid */
(function () {
  var me = document.currentScript;
  var tabNames = ((me && me.dataset.b7Tabs) || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  var hidePhone = !!me && me.dataset.b7HidePhone === 'true';
  var root = document.documentElement;
  var phone = window.matchMedia('(max-width: 767.98px)');
  var header = document.querySelector('.section-header');
  if (!header) return;
  var searchSec = document.querySelector('.section-7b-search');
  var msgSec = document.querySelector('.section-store-messages');
  var form = document.querySelector('[data-b7-search-form]');
  var formHome = form && form.parentElement;
  var input = form && form.querySelector('input[type="search"]');
  var secs = [header, searchSec, msgSec].filter(Boolean);
  var hidden = false, lastY = window.scrollY, threshold = Infinity;

  /* ---------- ONE sticky header (v2): same form at the top and when scrolled ---------- */
  var annUrl = (me && me.dataset.b7AnnUrl) || '';
  function annLink() {
    if (!annUrl) return;
    document.querySelectorAll('.announcement-bar .announcement__text').forEach(function (t) {
      if (t.querySelector('a')) return;
      var a = document.createElement('a');
      a.className = 'b7-ann-link';
      a.href = annUrl;
      while (t.firstChild) a.appendChild(t.firstChild);
      t.appendChild(a);
    });
  }

  function placeForm() {
    if (!form || !formHome) return;
    var row = header.querySelector('.logo-area');
    var right = header.querySelector('.logo-area__right');
    if (!phone.matches && row && right) {
      if (form.parentElement !== row) row.insertBefore(form, right);
      form.classList.add('b7s__form--inline');
      if (input) input.placeholder = input.dataset.placeholderFull || input.placeholder;
    } else {
      if (form.parentElement !== formHome) formHome.appendChild(form);
      form.classList.remove('b7s__form--inline');
      if (input) input.placeholder = input.dataset.placeholderCompact || input.placeholder;
    }
  }

  var tot = 0;
  function measure() {
    var ph = header.querySelector('page-header') || header;
    var row = ph.offsetHeight;
    var srch = (searchSec && phone.matches) ? searchSec.offsetHeight : 0;
    var msg = msgSec ? msgSec.offsetHeight : 0;
    tot = row + srch + msg;
    root.style.setProperty('--b7h-t2', row + 'px');
    root.style.setProperty('--b7h-t3', (row + srch) + 'px');
    root.style.setProperty('--b7h-tot', tot + 'px');
    // where the sticky part starts (announcement bar above it scrolls away)
    threshold = header.getBoundingClientRect().top + window.scrollY + tot;
  }

  function recheckNav() {
    // the menu column is as wide as the menu (--b7-navw); then Symmetry's own check sees it fits
    var nav = header.querySelector('#proxy-nav');
    var its = nav ? nav.querySelectorAll('.navigation__item') : [];
    if (its.length) {
      var f = its[0], l = its[its.length - 1];
      var w = Math.max(nav.scrollWidth, l.offsetLeft - f.offsetLeft + l.offsetWidth);
      root.style.setProperty('--b7-navw', Math.ceil(w) + 2 + 'px');
    }
    var ph = document.getElementById('pageheader');
    if (!ph || !window.theme || !theme.inlineNavigationCheck) return;
    ph.classList.add('pageheader--layout-inline-permitted');
    theme.inlineNavigationCheck();
  }

  /* push 7: ☰ or desktop menu by MEASURING the row: padding + logo + menu items + smallest search box + icons + gaps.
     Runs on every size change of the row (window resize, browser zoom, fonts loading). */
  var lastFit = null;
  function fit() {
    if (phone.matches) { root.classList.add('b7-burger'); if (lastFit === false) resetMenus(true); lastFit = true; return; }
    var la = header.querySelector('.logo-area');
    var nav = header.querySelector('#proxy-nav .navigation__tier-1');
    if (!la || !nav) return;
    var was = root.classList.contains('b7-burger');
    root.classList.remove('b7-burger');
    var ph = document.getElementById('pageheader');
    if (ph) ph.classList.add('pageheader--layout-inline-permitted');
    var cs = getComputedStyle(la);
    var gap = parseFloat(cs.columnGap) || 0;
    var navW = 0;
    nav.querySelectorAll(':scope > .navigation__item').forEach(function (li) {
      var m = getComputedStyle(li);
      navW += li.getBoundingClientRect().width + (parseFloat(m.marginLeft) || 0) + (parseFloat(m.marginRight) || 0);
    });
    var logo = la.querySelector('.logo-area__middle');
    var right = la.querySelector('.logo-area__right');
    var searchMin = 0, searchGap = 0;
    if (form && form.parentElement === la) {
      var fs = getComputedStyle(form);
      searchMin = parseFloat(fs.minWidth) || 0;
      searchGap = gap + (parseFloat(fs.marginLeft) || 0);
    }
    var need = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) +
      (logo ? logo.getBoundingClientRect().width : 0) + gap + Math.ceil(navW) + searchGap + searchMin + gap +
      (right ? right.getBoundingClientRect().width : 0) + 8;
    var burger = need > la.clientWidth;
    root.classList.toggle('b7-burger', burger);
    if (lastFit !== null && burger !== lastFit) resetMenus(burger);
    if (!burger && (was || lastFit === null)) recheckNav();
    lastFit = burger;
  }

  /* menu hotfix (Nov 3): crossing the measured switch while resizing resets the menus: desktop menu back = the drawer
     closes (scroll lock off); ☰ back = any open desktop dropdown closes. The drawer's sections start closed. Esc closes it. */
  function closeDrawer() {
    if (!document.body.classList.contains('reveal-mobile-nav')) return;
    var x = document.querySelector('.mobile-navigation-drawer .navigation__mobile-header .mobile-nav-toggle') || document.querySelector('.page-shade');
    if (x) x.click();
  }
  function resetMenus(burger) {
    document.querySelectorAll('.mobile-navigation-drawer .b7d-open').forEach(function (li) {
      li.classList.remove('b7d-open');
      var t = li.querySelector(':scope > .navigation__children-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!burger) { closeDrawer(); return; }
    header.querySelectorAll('.navigation__item--show-children').forEach(function (li) {
      li.classList.remove('navigation__item--show-children');
      if (li.firstElementChild) li.firstElementChild.setAttribute('aria-expanded', 'false');
    });
    header.classList.remove('section-header--nav-open', 'section-header--nav-hover');
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('reveal-mobile-nav')) closeDrawer();
  });

  function setHidden(h) {
    if (h === hidden) return;
    hidden = h;
    root.classList.toggle('b7-hide', h);
    if (!h && window.b7stickyShown) window.b7stickyShown();
  }

  var wantVar = '0px';
  // Symmetry rewrites this variable whenever the header resizes: put ours back
  new MutationObserver(function () {
    if (root.style.getPropertyValue('--theme-sticky-header-height') !== wantVar) root.style.setProperty('--theme-sticky-header-height', wantVar);
  }).observe(root, { attributes: true, attributeFilter: ['style'] });

  function setSymmetryVar() {
    wantVar = (hidden ? 0 : tot) + 'px';
    root.style.setProperty('--theme-sticky-header-height', wantVar);
  }

  // menu hotfix: an open drawer must not freeze the ☰/desktop switch (resizing across it closes the drawer); only typing does
  function typing() {
    return (form && form.contains(document.activeElement)) || root.classList.contains('b7ps-open-m');
  }
  function busy() {
    return (form && form.contains(document.activeElement)) || document.body.classList.contains('reveal-mobile-nav') || root.classList.contains('b7ps-open-m');
  }

  function update() {
    var y = window.scrollY;
    if (!busy()) {
      if (phone.matches && hidePhone && y > threshold) {
        if (y > lastY + 6) setHidden(true);
        else if (y < lastY - 6) setHidden(false);
      } else setHidden(false);
    }
    lastY = y;
    setSymmetryVar();
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });

  var rt, wasPhone = phone.matches;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    // not while typing: phone keyboards fire resize, and moving the form closes the keyboard
    rt = setTimeout(function () {
      if (typing()) return;
      if (phone.matches !== wasPhone) { wasPhone = phone.matches; placeForm(); fit(); }
      measure(); update();
    }, 150);
  });
  if (form) form.addEventListener('focusout', function () { setTimeout(update, 0); });
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { if (!busy()) { measure(); setSymmetryVar(); } });
    secs.forEach(function (el) { ro.observe(el); });
    var la0 = header.querySelector('.logo-area');
    if (la0) new ResizeObserver(function () { if (!typing()) fit(); }).observe(la0);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

  /* ---------- Phone drawer extras ---------- */
  function enhanceDrawer() {
    var d = document.querySelector('.mobile-navigation-drawer');
    if (!d || d.dataset.b7) return;
    d.dataset.b7 = '1';
    // push 7: flex column; Symmetry's own footer (country selector, social) scrolls with the list
    d.classList.add('b7d-flex');
    var symFoot = d.querySelector('.mobile-navigation-drawer__footer');
    if (symFoot && d.firstElementChild && d.firstElementChild !== symFoot) d.firstElementChild.appendChild(symFoot);
    var tpl = document.getElementById('b7-drawer-extras');
    if (tpl && tpl.content) {
      var frag = tpl.content.cloneNode(true);
      var riders = frag.querySelector('[data-b7d-riders]');
      var foot = frag.querySelector('[data-b7d-foot]');
      var list = d.querySelector('.navigation__tier-1');
      if (riders && list) list.insertAdjacentElement('beforebegin', riders);
      if (foot) {
        d.style.paddingBottom = '0';
        foot.style.paddingBottom = 'env(safe-area-inset-bottom, 0px)';
        d.appendChild(foot);
        var nav = d.firstElementChild;
        // the pinned footer's height: open category panels keep this much room at the bottom (7b-header CSS)
        var footH = function () {
          d.style.setProperty('--b7d-foot-h', foot.offsetHeight + 'px');
          if (nav && nav !== foot) nav.style.minHeight = 'calc(100% - ' + foot.offsetHeight + 'px)';
        };
        footH();
        d.addEventListener('transitionend', footH);
      }
    }
    if (!tabNames.length) { oneList(d); return; }
    var items = Array.prototype.slice.call(d.querySelectorAll('.navigation__tier-1 > .navigation__item--with-children'));
    var tabs = [];
    tabNames.forEach(function (n) {
      items.forEach(function (li) {
        var a = li.querySelector('.navigation__link');
        if (a && a.textContent.trim().toLowerCase() === n) tabs.push(li);
      });
    });
    var head = d.querySelector('.navigation__mobile-header');
    if (!tabs.length || !head) return;
    var bar = document.createElement('div');
    bar.className = 'b7d-tabs';
    bar.setAttribute('role', 'group');
    var buttons = tabs.map(function (li) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = li.querySelector('.navigation__link').textContent.trim();
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { openTab(li, b); });
      bar.appendChild(b);
      return b;
    });
    head.appendChild(bar);
    var allTxt = (me && me.dataset.b7All) || '';
    function openTab(li, b) {
      if (allTxt && !li.querySelector('.b7d-all')) {
        var top = li.querySelector('.navigation__link'), sub = li.querySelector('.navigation__tier-2');
        if (top && sub && top.getAttribute('href') && top.getAttribute('href') !== '#') {
          var d2 = document.createElement('li'); d2.className = 'b7d-all';
          var a = document.createElement('a'); a.href = top.getAttribute('href');
          a.textContent = allTxt + ' ' + top.textContent.trim() + ' \u2192'; d2.appendChild(a); sub.appendChild(d2);
        }
      }
      buttons.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      d.querySelectorAll('.navigation__tier-1 > .navigation__item--open').forEach(function (el) { el.classList.remove('navigation__item--open'); });
      var t = li.querySelector(':scope > .navigation__children-toggle');
      if (t) t.click();
    }
    d.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.mobile-nav-back')) buttons.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    });
    // open the first tab whenever the drawer opens
    new MutationObserver(function () {
      if (document.body.classList.contains('reveal-mobile-nav') && !d.querySelector('.navigation__tier-1 > .navigation__item--open')) {
        openTab(tabs[0], buttons[0]);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* push 6: no tabs = ONE list. A top-level item with children opens its sub-items in place (indented, 7b-header CSS)
     instead of Symmetry's slide-in panel; runs in the capture phase so Symmetry's own handler never sees the tap. */
  function oneList(d) {
    d.classList.add('b7d-one');
    var sel = '.navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle, .navigation__tier-1 > .navigation__item--with-children > .navigation__link[href="#"]';
    if (d.dataset.mobileExpandWithEntireLink === 'true') sel += ', .navigation__tier-1 > .navigation__item--with-children > .navigation__link';
    d.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest(sel);
      if (!t || !d.contains(t)) return;
      e.preventDefault();
      e.stopPropagation();
      var li = t.parentElement;
      // push 7: only ONE top-level section open at a time
      d.querySelectorAll('.navigation__tier-1 > .b7d-open').forEach(function (o) {
        if (o === li) return;
        o.classList.remove('b7d-open');
        var ot = o.querySelector(':scope > .navigation__children-toggle');
        if (ot) ot.setAttribute('aria-expanded', 'false');
      });
      var open = li.classList.toggle('b7d-open');
      var tg = li.querySelector(':scope > .navigation__children-toggle');
      if (tg) tg.setAttribute('aria-expanded', String(open));
      if (open && li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
    }, true);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.mobile-nav-toggle')) enhanceDrawer();
  }, true);

  /* Tracking (batch 7, SEO-AGENTS.md section 6): menu clicks, consult clicks, phone sticky header (10% sample).
     Shopify.analytics.publish -> custom pixel -> GA4. No personal data. */
  function pub(n, d) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); } catch (e) {}
  }
  var stickySent = false;
  window.b7stickyShown = function () {
    if (stickySent || !phone.matches) return;
    stickySent = true;
    if (Math.random() < 0.1) pub('7b_sticky_header_shown', { sample: 0.1 });
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var c = a.closest('[data-b7-consult]');
    if (c) pub('7b_consult_click', { source: c.dataset.b7Consult || 'other' });
    if (a.closest('.b7s, .b7ps-panel, .b7d-foot')) return;
    if (!a.closest('.section-header, .mobile-navigation-drawer')) return;
    var tier = a.closest('[class*="navigation__tier-"]');
    var m = tier && String(tier.className).match(/navigation__tier-(\d)/);
    pub('7b_menu_click', { level: m ? +m[1] : 1, label: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60) });
  }, true);

  placeForm();
  annLink();
  fit();
  function start() {
    fit();
    measure();
    update();
    enhanceDrawer();
    // Symmetry resets the sticky height variable on its own resize/load handlers
    setTimeout(function () { measure(); update(); }, 400);
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
  if (document.readyState !== 'loading') enhanceDrawer();
  else document.addEventListener('DOMContentLoaded', enhanceDrawer);
})();
